import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import './App.css';
import NewJoinForm from './components/NewJoineForm/NewJoinForm';
import Sdf from "./components/SelfDeclarationForm/Sdf";
import React from "react";
import Login from "./components/Authentication/Login";
import Epf from "./EPF/Epf";
import Form11 from "./Form11/Form11";
import FormF from "./FormF/FormF";
import FormQ from "./FormQ/FormQ";
import Nda from "./NDA/Nda";
import ThankYouPage from "./Thank You Page/ThankYou";
import { PrivateRoute } from "./privateRoute";
import CustomizedSnackbars from './snackbar/snackbar';
import Otpverify from "./components/Authentication/Otpverify";
import AdminUsers from "./components/Admin/adminUsers";
import AdminEmployees from "./components/Admin/adminEmployee";
import AdminLogin from "./components/Admin/adminLogin";
import AdminProfile from "./components/Admin/adminProfile";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './toast-theme.css';
import AdminSidebar from "./components/Admin/adminSidebar"
import AdminHeader from "./components/Admin/AdminHeader";
import EmployeeRecord from "./components/Admin/EmployeeRecord";
import {
  AdminHomeRedirect,
  LegacyFormRedirect,
  RequireHrAdmin,
  RequireSuperAdmin,
} from "./components/Admin/adminRoutes";
import AdminSectionA from "./components/Admin/AdminForms/Admin NewJoinee Form/AdminSectionA";
import AdminSectionB from "./components/Admin/AdminForms/Admin NewJoinee Form/AdminSectionB";
import AdminSectionC from "./components/Admin/AdminForms/Admin NewJoinee Form/AdminSectionC";
import AdminSectionD from "./components/Admin/AdminForms/Admin NewJoinee Form/AdminSectionD";
import AdminSectionE from "./components/Admin/AdminForms/Admin NewJoinee Form/AdminSectionE";
import FormStatusPanel from "./components/Sidebar/FormStatusPanel";
import { selectUser } from "./redux/modules/userSlice";
import { useSelector } from "react-redux";
import { PrivateAdmin, PrivateNewJoinee } from "./privateRoutes";
import AuthBootstrap from "./components/AuthBootstrap";
import JoineeHome from "./components/Joinee/JoineeHome";
import JoineeLayout from "./components/Joinee/JoineeLayout";
import RequireNewJoineeForm from "./components/Joinee/RequireNewJoineeForm";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { ADMIN_THEME } from "./config/adminTheme";

function App() {

  const location = useLocation();
  const { user } = useSelector(selectUser);
  const isJoineeUser =
    Boolean(user && user._id) && !user.isAdmin && !user.isSuperAdmin;
  const isAdminShell =
    Boolean(user && user._id) && Boolean(user.isAdmin || user.isSuperAdmin);
  const hideFormStatusPanel =
    isJoineeUser ||
    isAdminShell ||
    location.pathname.includes('profile') ||
    location.pathname.includes('login') ||
    location.pathname.includes('otp-verify') ||
    location.pathname.includes('AdminDashboard') ||
    location.pathname.includes('AdminUsers') ||
    location.pathname.includes('AdminEmployees') ||
    location.pathname.includes('AdminLogin') ||
    location.pathname.includes('AdminProfile') ||
    location.pathname === '/' ||
    location.pathname === '/thankyou';
  const showFormStatusPanel = Boolean(user && user._id) && !hideFormStatusPanel;

  const routes = (
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/otp-verify" element={<Otpverify />} />
            <Route path="/AdminLogin" element={<AdminLogin />} />
            <Route element={<PrivateNewJoinee />}>
              <Route path="/" element={<JoineeHome />} />
              <Route element={<JoineeLayout />}>
                <Route path="/new-joinee" element={<NewJoinForm />} />
                <Route element={<RequireNewJoineeForm />}>
                  <Route path="/Epf" element={<Epf />} />
                  <Route path="/epf" element={<Epf />} />
                  <Route path="/Sdf" element={<Sdf />} />
                  <Route path="/sdf" element={<Sdf />} />
                  <Route path="/form11" element={<Form11 />} />
                  <Route path="/formf" element={<FormF />} />
                  <Route path="/formQ" element={<FormQ />} />
                  <Route path="/formq" element={<FormQ />} />
                  <Route path="/Nda" element={<Nda />} />
                  <Route path="/nda" element={<Nda />} />
                </Route>
                <Route path="/thankyou" element={<ThankYouPage />} />
                <Route path="/profile" element={<AdminProfile />} />
              </Route>
            </Route>

            <Route element={<PrivateAdmin />}>
              <Route path="/AdminDashboard" element={<AdminHomeRedirect />} />
              <Route path="/AdminProfile" element={<AdminProfile />} />
              <Route element={<RequireSuperAdmin />}>
                <Route path="/AdminUsers" element={<AdminUsers />} />
              </Route>
              <Route element={<RequireHrAdmin />}>
                <Route path="/AdminEmployees" element={<AdminEmployees />} />
                <Route path="/AdminEmployeeRecord/:id" element={<EmployeeRecord />} />
                <Route path="/AdminNewJoineeForm/:id" element={<LegacyFormRedirect formId="newJoinee" />} />
                <Route path="/AdminSDF/:id" element={<LegacyFormRedirect formId="sdf" />} />
                <Route path="/AdminEPF/:id" element={<LegacyFormRedirect formId="epf" />} />
                <Route path="/AdminForm11/:id" element={<LegacyFormRedirect formId="form11" />} />
                <Route path="/AdminFormF/:id" element={<LegacyFormRedirect formId="formF" />} />
                <Route path="/AdminFormQ/:id" element={<LegacyFormRedirect formId="formQ" />} />
                <Route path="/AdminNda/:id" element={<LegacyFormRedirect formId="nda" />} />
              </Route>
              <Route path="/AdminSectionA" element={<AdminSectionA />} />
              <Route path="/AdminSectionB" element={<AdminSectionB />} />
              <Route path="/AdminSectionC" element={<AdminSectionC />} />
              <Route path="/AdminSectionD" element={<AdminSectionD />} />
              <Route path="/AdminSectionE" element={<AdminSectionE />} />
            </Route>
          </Routes>
  );

  const shell = isAdminShell ? (
      <div className="admin-theme" style={{ display: "flex", flexDirection: "column", height: "100vh", width: "100%" }}>
        <AdminHeader />
        <div style={{ flex: 1, minHeight: 0, overflowY: "auto", display: "flex", flexDirection: "column" }}>
          {routes}
        </div>
      </div>
  ) : (
      <div className="d-flex w-100">
        <div>
          <AdminSidebar />
          {showFormStatusPanel ? <FormStatusPanel /> : ''}
        </div>

        <div className="w-100">
          {routes}
        </div>
      </div>
  );

  return (
    <AuthBootstrap>
      {isAdminShell ? (
        <ThemeProvider theme={ADMIN_THEME}>
          <CssBaseline />
          {shell}
        </ThemeProvider>
      ) : (
        shell
      )}

      <ToastContainer autoClose={3000} position="bottom-left" theme="light" newestOnTop />
    </AuthBootstrap>
  );
}

export default App;
